import React from "react";
import Pages404 from "pages/Utility/pages-404";
import Pages500 from "pages/Utility/pages-500";

import { Redirect } from "react-router";
import Home from "pages/Website/Home";
import Profile from "pages/Website/Profile";
import AdvancedFilter from "pages/Website/AdvancedFilter";
import ListCompare from "pages/Website/AdvancedFilter/ListCompare";
import LoginPage from "pages/Website/Authentication/Login";
import Register from "pages/Website/Authentication/Register";
import Resetpassword from "pages/Website/Authentication/Resetpassword";
import ForgetPassword from "pages/Website/Authentication/ForgetPassword";
import CompoundDetails from "pages/Website/CompoundDetails";
import Resale from "pages/Website/Resale";
import PropertyDetails from "pages/Website/PropertyDetails";
import CreateResale from "pages/Website/Resale/CreateResale/index";
import CompoundsPage from "pages/Website/Compounds";
import ResalesPage from "pages/Website/Resales";
import ResaleDetailsPage from "pages/Website/ResaleDetails";
import Logout from "pages/Website/Authentication/Logout";
import ContactUs from "pages/Website/ContactUs";
import AboutUs from "pages/Website/AboutUs";
import TermsPage from "pages/Website/TermsPage";
import DealSatusPage from "pages/Website/DealSatusPage";
import ResaleArea from "pages/Website/ResaleArea";
import PropertyBuyDetails from "pages/Website/PropertyDetails/PropertyBuyDetails";
import ResaleBuyDetailsPage from "pages/Website/ResaleDetails/ResaleBuyDetails";
import AuthCard from "components/Website/Cards/AuthCard";
import SpecialOffers from "pages/Website/SpecialOffers";

const websiteRoutes = [
	//  { path: "/home", component: Home },
	// { path: "/advanced-filter", component: AdvancedFilter },
	{ path: "/compound-details/:id", component: CompoundDetails },
	{ path: "/resale-view/:id", component: ResaleDetailsPage },
	{ path: "/resale-view/:id/details", component: ResaleBuyDetailsPage },
	{ path: "/property-details/:id", component: PropertyDetails },
	{ path: "/property-details/:id/details", component: PropertyBuyDetails },
	{ path: "/compare-list/:ids?", component: ListCompare },
	{ path: "/profile/:interests?", component: Profile },
	{ path: "/resale", component: Resale },
	{ path: "/special-offers", component: SpecialOffers },
	{ path: "/edit-resale/:id", component: CreateResale },
	{ path: "/logout", component: Logout },
	{ path: "/create-resale", component: CreateResale },
	{ path: "/terms", component: TermsPage },

	// {
	//   path: `*`,
	//   component: () => <Redirect to={`/home`} />,
	// },
];
const websiteAuthRoutes = [
	{ path: "/login", component: AuthCard },
	{ path: "/", component: Home },
	{ path: "/compounds", component: ResalesPage },
	// { path: "/compounds", component: CompoundsPage }, test path
	{ path: "/compounds/new-projects", component: CompoundsPage },
	{ path: "/resales/:type?/:id?", component: ResalesPage },
	{ path: "/resale/:areaId", component: ResaleArea },
	{ path: "/resale", component: Resale },
	{ path: "/advanced-filter", component: AdvancedFilter },
	{ path: "/contact-us", component: ContactUs },
	{ path: "/about-us", component: AboutUs },
	// { path: "/login", component: LoginPage },
	// { path: "/register", component: Register },
	{ path: "/forget-password", component: ForgetPassword },
	{ path: "/reset-password", component: Resetpassword },
	{ path: "/pages-500", component: Pages500 },
	{ path: "/deal-status/:id?/:status?", component: DealSatusPage },
];

export { websiteAuthRoutes, websiteRoutes };
